// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar-m__searchBar___1DXqU","searchInput":"SearchBar-m__searchInput___kMVFR"};